export default __webpack_public_path__ + "static/media/Backgroundnew.svg.eaf49c09.svg";